/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import type {
  GetApiV1ExamExamitemidApproveEditorQueryResponse,
  GetApiV1ExamExamitemidApproveEditorPathParams,
  GetApiV1ExamExamitemidApproveEditor401,
  GetApiV1ExamExamitemidApproveEditor404,
  GetApiV1ExamExamitemidApproveEditor500,
} from "../../types/examQuestionLibraryController/GetApiV1ExamExamitemidApproveEditor.ts";
import { queryOptions, useQuery } from "@tanstack/react-query";
import { getApiV1ExamExamitemidApproveEditor } from "../../clients/examQuestionLibraryController/getApiV1ExamExamitemidApproveEditor.ts";

export const getApiV1ExamExamitemidApproveEditorQueryKey = (
  examItemId: GetApiV1ExamExamitemidApproveEditorPathParams["examItemId"],
) =>
  [
    {
      url: "/api/v1/exam/:examItemId/approve-editor",
      params: { examItemId: examItemId },
    },
  ] as const;

export type GetApiV1ExamExamitemidApproveEditorQueryKey = ReturnType<
  typeof getApiV1ExamExamitemidApproveEditorQueryKey
>;

export function getApiV1ExamExamitemidApproveEditorQueryOptions(
  examItemId: GetApiV1ExamExamitemidApproveEditorPathParams["examItemId"],
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const queryKey = getApiV1ExamExamitemidApproveEditorQueryKey(examItemId);
  return queryOptions<
    GetApiV1ExamExamitemidApproveEditorQueryResponse,
    ResponseErrorConfig<
      | GetApiV1ExamExamitemidApproveEditor401
      | GetApiV1ExamExamitemidApproveEditor404
      | GetApiV1ExamExamitemidApproveEditor500
    >,
    GetApiV1ExamExamitemidApproveEditorQueryResponse,
    typeof queryKey
  >({
    enabled: !!examItemId,
    queryKey,
    queryFn: async ({ signal }) => {
      return getApiV1ExamExamitemidApproveEditor(examItemId, {
        ...config,
        signal: config.signal ?? signal,
      });
    },
  });
}

/**
 * @description Retorna os dados necessários para o editor de aprovação de uma questão da biblioteca, incluindo o status atual, justificativa e se o usuário logado possui permissão de aprovação. **(Requer Authorization para autenticação)**
 * @summary Obter dados do editor de aprovação de questão (Requer Authorization para autenticação)
 * {@link /api/v1/exam/:examItemId/approve-editor}
 */
export function useGetApiV1ExamExamitemidApproveEditor<
  TData = GetApiV1ExamExamitemidApproveEditorQueryResponse,
  TQueryData = GetApiV1ExamExamitemidApproveEditorQueryResponse,
  TQueryKey extends QueryKey = GetApiV1ExamExamitemidApproveEditorQueryKey,
>(
  examItemId: GetApiV1ExamExamitemidApproveEditorPathParams["examItemId"],
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetApiV1ExamExamitemidApproveEditorQueryResponse,
        ResponseErrorConfig<
          | GetApiV1ExamExamitemidApproveEditor401
          | GetApiV1ExamExamitemidApproveEditor404
          | GetApiV1ExamExamitemidApproveEditor500
        >,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: Client };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...resolvedOptions } = queryConfig;
  const queryKey =
    resolvedOptions?.queryKey ??
    getApiV1ExamExamitemidApproveEditorQueryKey(examItemId);

  const query = useQuery(
    {
      ...getApiV1ExamExamitemidApproveEditorQueryOptions(examItemId, config),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<
    TData,
    ResponseErrorConfig<
      | GetApiV1ExamExamitemidApproveEditor401
      | GetApiV1ExamExamitemidApproveEditor404
      | GetApiV1ExamExamitemidApproveEditor500
    >
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}
